export const validateEmail = (email: string) => {
    return new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/).test(email) || email.length === 0;
};

export const validatePhone = (phone: string) => {
    // Initial plus sign or digit, rest need to be digits, dashes or spaces
    // Special case for Swedish mobile phones - do not allow country code combined with 07
    const digits = phone.replaceAll(/\d[\-\s]\d/g, '11').length;
    const requiredLength = phone.startsWith('+') ? 7 : 5;
    return (
        (new RegExp(/^[+\d]?(?:[\d\-\s]*)$/).test(phone) &&
            phone.substring(0, 5) !== '+4607' &&
            digits >= requiredLength &&
            digits <= 15) ||
        phone.length === 0
    );
};

export function validateBookingCode(bookingCode: string) {
    return new RegExp(/^\w+-\w+$/).test(bookingCode);
}
